import React from 'react';

export default function ExamList({ items, level, onEdit, onDelete, onOpen, onManageGroups, onStatusChange = () => {} }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {items.map(item => (
        <div key={item.id} className="p-4 bg-white rounded-lg shadow hover:shadow-lg transition flex justify-between items-start">
          <div>
            <div className="flex items-center gap-2">
              <span className="font-medium">{item.name || item.title}</span>
              {item.status && (
                <span className={`text-xs font-semibold px-2 py-1 rounded ${item.status === 'active' ? 'bg-green-100 text-green-700' : item.status === 'draft' ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700'}`}>
                  {item.status}
                </span>
              )}
            </div>
            {item.slug && <div className="text-sm text-gray-500">slug: {item.slug}</div>}
            {item.year && <div className="text-sm text-gray-500">year: {item.year}</div>}
            {item.duration_minutes != null && <div className="text-sm text-gray-500">duration: {item.duration_minutes}m</div>}
            {item.total_questions != null && <div className="text-sm text-gray-500">questions: {item.total_questions}</div>}
            {item.marks_per_correct != null && <div className="text-sm text-gray-500">marks/correct: {item.marks_per_correct}</div>}
            {item.negative_mark != null && <div className="text-sm text-gray-500">negative (wrong): {item.negative_mark}</div>}
            {item.total_marks != null && <div className="text-sm text-gray-500">total marks: {item.total_marks}</div>}
          </div>
          <div className="space-x-2">
            <select
              value={item.status || 'active'}
              onChange={(e) => {
                const newStatus = e.target.value;
                if (newStatus === (item.status || 'active')) return;
                onStatusChange(item, newStatus);
              }}
              className="border border-gray-300 rounded px-2 py-1 text-sm"
            >
              <option value="active">Active</option>
              <option value="draft">Draft</option>
              <option value="suspended">Suspended</option>
            </select>
            <button className="text-blue-500 hover:text-blue-700" onClick={() => onEdit(item)}>
              Edit
            </button>
            <button className="text-red-500 hover:text-red-700" onClick={() => onDelete(item.id)}>
              Delete
            </button>
            {level !== 'test' ? (
              <button className="text-green-500 hover:text-green-700" onClick={() => onOpen(item)}>
                Open
              </button>
            ) : (
              <button className="text-green-500 hover:text-green-700" onClick={() => onManageGroups(item)}>
                Manage Groups
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
